/** @jsx h */

import { useRef, useEffect } from 'preact/hooks';
import { labels } from '../config';
import ResultList from './ResultList';
import Pagination from './Pagination';

const ResultContainer = ({
  searchType,
  allResultCount,
  list,
  listCount,
  pagination,
  loadMore,
  pluginNamespace,
  isError,
  resultIsEmpty,
  paginationInputEl,
  inputQuery,
  restrictionFilters,
}) => {
  const firstNewResultRef = useRef(null);

  useEffect(() => {
    firstNewResultRef.current?.focus();
  }, [list.length]);

  return (
    <section className="search__results" aria-labelledby="search-result-heading">
      <h2 id="search__results-heading" className="headline headline--module-3">
        {labels.results.heading}
      </h2>
      <div className="search__results-inner">
        <ResultList
          searchType={searchType}
          list={list}
          listCount={listCount}
          restrictionFilters={restrictionFilters}
        />
      </div>
      <Pagination
        pagination={pagination}
        triggerLoadMore={loadMore}
        pluginNamespace={pluginNamespace}
        paginationInputEl={paginationInputEl}
      />
    </section>
  );
};

export default ResultContainer;
